import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';

const CustomDatePicker = ({ selectedDate, onChange }) => {
  const [internalDate, setInternalDate] = useState(selectedDate);

  useEffect(() => {
    setInternalDate(selectedDate);
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setInternalDate(date);
    onChange(date);
  };

  const handleMonthChange = (date) => {
    setInternalDate((prevDate) =>
      prevDate ? new Date(date.getFullYear(), date.getMonth(), Math.min(prevDate.getDate(), 28)) : null
    );
  };

  const handleYearChange = (date) => {
    setInternalDate((prevDate) =>
      prevDate ? new Date(date.getFullYear(), prevDate.getMonth(), Math.min(prevDate.getDate(), 28)) : null
    );
  };

  return (
    <div className="custom-date-picker">
      <DatePicker
        selected={internalDate}
        onChange={handleDateChange}
        dateFormat="MM/dd/yyyy"
        placeholderText="MM/DD/YYYY"
        className="custom-input"
        popperPlacement="bottom-start"
        onKeyDown={(e) => e.preventDefault()}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        onMonthChange={handleMonthChange}
        onYearChange={handleYearChange}
      />
    </div>
  );
};

export default CustomDatePicker;
